export default __webpack_public_path__ + "94b768c07879dde09ab4d5f6ad92cbc6.ttf";